import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule, Routes } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { environment } from 'src/environments/environment';
import { TokenInterceptor } from './modules/auth/services/token.interceptor';
import { PortalHttpActivityInterceptor } from './portal-ui/shared/ui/portal-load-status/portal-http-activity.interceptor';
import { PublicAuthComponent } from './public-auth.component';
import { PublicAuthRootRedirectComponent } from './public-auth-root-redirect.component';
import versionInfo from 'src/assets/version.json';

const routes: Routes = [
  {
    path: 'reset-password',
    redirectTo: 'auth/reset-password',
    pathMatch: 'prefix',
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'error',
    loadChildren: () =>
      import('./modules/errors/errors.module').then((m) => m.ErrorsModule),
  },
  {
    path: 'pay',
    loadChildren: () =>
      import('./modules/guest-pay/guest-pay.module').then((m) => m.GuestPayModule),
  },
  {
    // Public quote accept links from email/PDF (`/quote/{token}`).
    path: 'quote',
    loadChildren: () =>
      import('./modules/public-quote/public-quote.module').then((m) => m.PublicQuoteModule),
  },
  {
    // Secure single-use action links from notification emails (`/mail-action/{token}`).
    path: 'mail-action',
    loadChildren: () =>
      import('./modules/mail-action/mail-action.module').then((m) => m.MailActionModule),
  },
  { path: '', pathMatch: 'full', component: PublicAuthRootRedirectComponent },
  { path: '**', redirectTo: 'auth/sign-in' }];

export function PublicAuthHttpLoaderFactory(http: HttpClient) {
  const bust = environment.production
    ? String((versionInfo as { buildId?: string }).buildId || environment.appVersion)
    : String(Date.now());
  return new TranslateHttpLoader(
    http,
    '/__login/assets/i18n/',
    `.json?v=${encodeURIComponent(bust)}`,
  );
}

@NgModule({
  declarations: [PublicAuthComponent, PublicAuthRootRedirectComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    NgbModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: PublicAuthHttpLoaderFactory,
        deps: [HttpClient],
      },
      defaultLanguage: 'en',
    }),
    RouterModule.forRoot(routes),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: PortalHttpActivityInterceptor, multi: true },
    provideAnimationsAsync()],
  bootstrap: [PublicAuthComponent],
})
export class PublicAuthModule {}
